import namor from "namor"
import moment from 'moment'
import { isNumeric, range } from "../../../lib/util";

const newPerson = () => {
  const statusChance = Math.random();
  return {
    projectId: Math.floor(Math.random() * 100),
    title: namor.generate({ words: 1, numbers: 0 }),
    client: namor.generate({ words: 1, numbers: 0 }),
    status:
      statusChance > 0.66
        ? "approved"
        : statusChance > 0.33 ? "pending" : "rejected",
    createdAt: (new Date()).toString()
  };
};

export function makeData(len = 5553) {
  return range(0, len).map(d => {
    return {
      ...newPerson(),
      children: range(0, 10).map(newPerson)
    };
  });
}

export function convertDate(date) {
  return moment.utc(date, 'YYYY-MM-DD HH:mm:ss').local().format("DD MMM YYYY, h:mm a")
}

export function convertPendingFor(time) {
  if (!time) {
    return "0 s";
  }

  const hours = time.match(/\d*\.?\d*(?=h)/i);

  if (hours && parseInt(hours[0]) !== 0 && isNumeric(hours[0])){
    return `${parseInt(hours[0])} h`;
  }

  const mins = time.match(/\d*\.?\d*(?=m)/i);

  if (mins && parseInt(mins[0]) !== 0 && isNumeric(mins[0])) {
    return `${parseInt(mins[0])} m`;
  }

  const secs = time.match(/\d*\.?\d*(?=s)/i);

  if (secs && parseInt(secs[0]) !== 0 && isNumeric(secs[0])) {
    return `${parseInt(secs[0])} s`;
  }

  return "";
}